import { createTheme } from '@mui/material/styles'
import type {} from '@mui/x-date-pickers/themeAugmentation'

import breakpoints from './breakpoints'
import components from './components'
import { getPalette } from './palette'
import typography from './typography'

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

export const configureTheme = () => {

  const themeOptions = {
    breakpoints,
    components,
    palette: getPalette(),
    typography
  }

  const theme = createTheme(themeOptions)

  return theme
}